import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import { SwitchButtonView } from '@ckeditor/ckeditor5-ui';

class TrackChangesSwitchUI extends Plugin {
  init() {
    const editor = this.editor;
    const trackChangesPlugin = editor.plugins.get('TrackChanges');
    const trackChangesCommand = editor.commands.get('trackChanges');

    if (!trackChangesPlugin) {
      console.error({'missingPlugin': 'TrackChanges'});
      return;
    }

    editor.ui.componentFactory.add('trackChangesSwitch', () => {
      const switchButton = new SwitchButtonView();

      switchButton.set({
        class: 'ck-track-changes-switch',
        label: 'Suggesting',
        withText: true,
        isOn: false,
      });

      switchButton.on('execute', () => {
        switchButton.isOn = !switchButton.isOn;
        editor.execute('trackChanges');
      });

      trackChangesCommand.on('change:value', (eventInfo, name, value) => {
        const isOn = switchButton.isOn;
        const isEqualValue = isOn === value;
        if (!isEqualValue) switchButton.isOn = value;
      });

      return switchButton;
    });
  }
}

export default TrackChangesSwitchUI;
